import './crew.css';
import CrewItem from './crew-item';
import crewTitle from '../images/crew-title-desktop.png';
import mediaTitleMobile from  '../images/crew-title-mobile.png';
import photoDogi from "../images/Dogi-profile.jpg";
import photoDogiMobile from "../images/Dogi-profile-mobile.jpg";
import photoKesha from "../images/Kesha-profile.jpg";
import photoKeshaMobile from "../images/Kesha-profile-mobile.jpg";
import photoUnknownHero from "../images/unknown-hero-profile.jpg";
import photoUnknownHeroMobile from "../images/unknown-hero-profile.jpg";

function CrewSection(crew) {

return (
	<div id="crew-section">
	  	
	  	<span className="anchor" id="band-members"></span>
	  	
	  	<div className="row container-fluid bg-black bg-breaks">
			    
		    <div className="col-md-1 themed-grid-col"></div>
	        
	        <div className="col-md-10 themed-grid-col">
					<div className="text-center" id="band-members-title">
						<picture>
					  		<source srcSet={mediaTitleMobile} media="(max-width: 699px)"/>
					  		<img id="crew-title"
								src={crewTitle} 
								className="img-fluid" alt="Crew Logo"
								loading="lazy"
								height="144px" width="443px" style={{ maxWidth: '100%', height: 'auto'}}
								data-font-name="adnp1" data-font-url="https://fontmeme.com/graffiti-creator/"/>
						</picture>
					</div>
					
					<div id="band-members-content" className="row row-cols-1 row-cols-md-3 g-4">

						<CrewItem
							picture={photoKesha}
							pictureMobile={photoKeshaMobile}
							name="Kesha Bender"
							shortBio="Born in Siberia and raised under the burning sun of Ukraine, Kesha pocesses the famous rebellious spirit of Cossacks, which results in roaring guitar riffs and dramatic melodies."
						/>

						<CrewItem
							picture={photoUnknownHero}
							pictureMobile={photoUnknownHeroMobile}
							name="Unknown Bass hero"
							shortBio="Master of earth-shaking grooves and bone-rattling low frequencies. A bass sound powerful enough to shake the walls, rattle the bar, and wake the dead for one last encore. Yet to be discovered…"
						/>

						<CrewItem
							picture={photoDogi}
							pictureMobile={photoDogiMobile}
							name="Mr. Dogi T."
							shortBio="Like a good old whiskey, from the age of 15 Mr.T started to rock hard in bars and clubs of Berlin. Relentless heavy kick mixed with his oriental roots brings a special touch to heavy metal coctail."
						/>

						
					</div>
					<br/>			
		        </div>
		        
			    <div className="col-md-1 themed-grid-col"></div>
		  	
		  	</div>
	  	
	</div>
  );
}

export default CrewSection;